import React from 'react';

import { BuildFragFragment, DiffViewFragmentFragment, DiffsOrderBy } from '../../graphql/__generated__/graphql';
import DiffHeaderInfo from './DiffHeaderInfo';
import DiffHeaderNav from './DiffHeaderNav';
import DiffHeaderSort from './DiffHeaderSort';
import DiffHeaderStatus from './DiffHeaderStatus';

type Props = {
  build: Exclude<BuildFragFragment, undefined | null>,
  diffView: DiffViewFragmentFragment;
  diffOrder: DiffsOrderBy;
  setDiffsOrder: (order: DiffsOrderBy) => void;
}

const DiffHeader: React.FC<Props> = (
  { build, diffView, diffOrder, setDiffsOrder },
) => (
  <div className="flex flex-col bg-white border-0 border-b border-solid border-gray-200">
    <div className="-mt-px px-2 flex items-center justify-between">
      <DiffHeaderInfo
        diffView={diffView}
        project={build.project ?? undefined}
      />
      <div className="flex items-center gap-2">
        <DiffHeaderSort
          diffOrder={diffOrder}
          setDiffsOrder={setDiffsOrder}
        />
        <DiffHeaderNav
          build={build}
          diffOrder={diffOrder}
          diffView={diffView}
        />
      </div>
    </div>

    <DiffHeaderStatus
      error={build.error}
      status={build.status}
    />
  </div>
);
export default DiffHeader;
